import React from "react";

interface SearchQueryIconProps {
  size?: number | string;
  className?: string;
  onClick?: () => void;
  color?: string
}

const PageSearchIcon: React.FC<SearchQueryIconProps> = ({
  size = 18,
  className,
  onClick,
  color = '#0556CB',
}) => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.25 3C9.39 3 3 9.39 3 17.25C3 25.11 9.39 31.5 17.25 31.5C25.11 31.5 31.5 25.11 31.5 17.25C31.5 9.39 25.11 3 17.25 3ZM17.25 20.625H12.75C12.135 20.625 11.625 20.115 11.625 19.5C11.625 18.885 12.135 18.375 12.75 18.375H17.25C17.865 18.375 18.375 18.885 18.375 19.5C18.375 20.115 17.865 20.625 17.25 20.625ZM21.75 16.125H12.75C12.135 16.125 11.625 15.615 11.625 15C11.625 14.385 12.135 13.875 12.75 13.875H21.75C22.365 13.875 22.875 14.385 22.875 15C22.875 15.615 22.365 16.125 21.75 16.125Z" fill={color} fillOpacity="0.3" />
    <path d="M31.9508 32.9979C31.6808 32.9979 31.4108 32.8929 31.2158 32.6979L28.4258 29.9079C28.0208 29.5029 28.0208 28.8429 28.4258 28.4229C28.8308 28.0179 29.4908 28.0179 29.9108 28.4229L32.7008 31.2129C33.1058 31.6179 33.1058 32.2779 32.7008 32.6979C32.4908 32.8929 32.2208 32.9979 31.9508 32.9979Z" fill={color} fillOpacity="0.3" />
  </svg>

);

export default PageSearchIcon;
